module.exports={render:function (){with(this) {
  return _h('a', {
    staticClass: "button is-primary is-outlined",
    on: {
      "click": function($event) {
        run(code)
      }
    }
  }, [_m(0), " ", _m(1)])
}},staticRenderFns: [function (){with(this) {
  return _h('span', {
    staticClass: "icon"
  }, [_h('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}},function (){with(this) {
  return _h('span', ["Run"])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3093f32!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RunButton.vue
// module id = 259
// module chunks = 2